// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__LODv0","button":"Stepper_button__0JB53","input":"Stepper_input__Zn2jU"};